var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EFFEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 24L11.8333 17.7778V16H14.75C15.4861 16 16.1215 15.7444 16.6563 15.2333C17.191 14.7222 17.5139 14.0889 17.625 13.3333H11V11.5556H17.375C17.1389 11.037 16.7882 10.6111 16.3229 10.2778C15.8576 9.94444 15.3333 9.77778 14.75 9.77778H11V8H21V9.77778H18.2917C18.4861 10.0296 18.6597 10.3037 18.8125 10.6C18.9653 10.8963 19.0833 11.2148 19.1667 11.5556H21V13.3333H19.3125C19.2014 14.5926 18.7153 15.6481 17.8542 16.5C16.9931 17.3519 15.9583 17.7778 14.75 17.7778H14.1458L19.75 24H17.4375Z",
    fill: "#4B9D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsCircled);
export default __webpack_public_path__ + "static/media/payments_circled.c796832690a1cf0243c7e88af650b4e8.svg";
export { ForwardRef as ReactComponent };